import differenceInHours from 'date-fns/differenceInHours';
import { getCP3Env } from '../CP3Config';

/**
 * @function
 * @param {Object} lastDismissedByUser - An object containing the last date where this dialog was
 *      dismissed by user.
 * @param {string} username - A given username
 *
 * @returns {boolean} - True, if the user has already dismissed the modal in a predefined & configurable hour timelapse.
 */
export const hasDismissedSwitchModal = (lastDismissedByUser, username) => {
	const hiddenTimeHours =
		+getCP3Env('REACT_APP_HIDE_SWITCH_CP4_MODAL_HOURS') || 48;

	return (
		!!lastDismissedByUser[username] &&
		Math.abs(
			differenceInHours(new Date(), new Date(lastDismissedByUser[username]))
		) < hiddenTimeHours
	);
};
